export enum EstadoSolicitudModificada {
  Aprobado,
  Rechazado
}
